import React, { FC } from 'react';
import { Stack } from '@mui/material';
import { ActivityLogTabProps } from './ActivityLogTabProps';
import Text from '@ingka/text';
import ListView, { ListViewItem } from '@ingka/list-view';
import { convertActivityLogRawToData } from './utils';
import useChangeLog from '../../hooks/useChangeLog';
import Button from '@ingka/button';
import Loading, { LoadingBall } from '@ingka/loading';
import skapaColours from '@ingka/variables/colours-css';

const ActivityLogTab: FC<ActivityLogTabProps> = ({ projectId }) => {
  const { changeLog, fetchChangeLogHandler, loading } = useChangeLog();
  const activityLogData =
    changeLog && convertActivityLogRawToData(changeLog?.content || []);

  if (!activityLogData?.length) {
    return <Text>No activity log available</Text>;
  }
  const fetchMoreHandler = () => {
    fetchChangeLogHandler(projectId);
  };
  return (
    <Stack spacing={5}>
      {loading && activityLogData?.length === 0 ? (
        <Loading text="Loading..." labelTransitions>
          <LoadingBall />
        </Loading>
      ) : (
        <>
          {activityLogData?.map((group, idx) => (
            <Stack key={`activity-log-stack-${idx}`}>
              <Text tagName={'h1'} textStyle="Body.L">
                {group.date}
              </Text>
              <ListView id={`activity-log-list-${idx}`}>
                {group.entries.map((entry) => (
                  <ListViewItem
                    emphasised
                    title={entry.title}
                    description={entry.details}
                    addOn={
                      <Text
                        textStyle="Body.S"
                        color={skapaColours.colourTextAndIcon3}
                      >
                        {entry.time}
                      </Text>
                    }
                  />
                ))}
              </ListView>
            </Stack>
          ))}
          {!changeLog?.last && (
            <Stack alignItems="flex-start" sx={{ mb: 4 }}>
              <Button
                type="secondary"
                size={'small'}
                fluid={false}
                style={{ width: 164, height: 40 }}
                onClick={fetchMoreHandler}
              >
                Show more
              </Button>
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};

export default ActivityLogTab;
